<div class="c-card-list c-card-list--response c-card-list--fix-max-height"
  [ngClass]="{'c-card-list--custom': holiday.isCustom}">
  <div class="c-card-images">
    <div (click)="goToDetail(holiday)" class="mobile-overlay"></div>
    <div class="c-card-tag__custom" [hidden]="!holiday.isCustom">
      <i class="icon-target"></i> Vacanza consigliata
    </div>
    <swiper [config]="config" [(index)]="index" (swiperTouchStart)="showMoreImages()" (click)="showMoreImages()"
            class="c-card-images__carousel">
      <div class="c-card-images__carousel-item fix-hidden-scroll"
           *ngIf="holiday.accomodation && holiday.accomodation.image">
        <img [src]="holiday.accomodation.image | cdnify" class="c-card-image c-card-image--fix-width"
             [showPlaceholderOnError]="true">
        <!-- <div class="c-card-image"
             [ngStyle]="{'background-image': 'url(' + (holiday.accomodation.image | cdnify) + ')'}"></div> -->
      </div>
      <div class="c-card-images__carousel-item fix-hidden-scroll" *ngIf="holiday.tour && holiday.tour.image">
        <img [src]="holiday.tour.image | cdnify" class="c-card-image c-card-image--fix-width"
             [showPlaceholderOnError]="true">
        <!-- <div class="c-card-image" [ngStyle]="{'background-image': 'url(' + (holiday.tour.image | cdnify) + ')'}"></div> -->
      </div>
      <div class="c-card-images__carousel-item fix-hidden-scroll" *ngFor="let image of images$ | async">
        <img [src]="image | cdnify" class="c-card-image c-card-image--fix-width" [showPlaceholderOnError]="true">
        <!-- <div class="c-card-image" [ngStyle]="{'background-image': 'url(' + (image | cdnify) + ')'}"></div> -->
      </div>
    </swiper>
    <div class="c-card-images__logo-to">
      <img [src]="holiday.logo ? holiday.logo : (holiday.tourOperatorLogo | cdnify)" [alt]="holiday.title" width="100%">
    </div>
    <div class="c-card-info--mobile">
      <div class="c-card-info__header">
        <h4 class="h4 c-card-title">
          {{holiday.title}}
          <span class="c-card-stars">
            <span>{{holiday.accomodation?.category?.value}}</span>
            <span>
              <i [ngClass]="holiday.accomodation?.category?.icon"></i>
            </span>
            <span>{{holiday.accomodation?.category?.extra}}</span>
          </span>
        </h4>
        <h6 class="h6 c-card-sub-title">{{(holiday.destination | getDataFromMapping:'destination' | async)?.Name}}</h6>
      </div>
    </div>
  </div>

  <div class="c-card-info">

    <a class="c-card-info--desktop" dynamicNavigation [href]="getDetailUrl(holiday)">
      <h5 class="c-card-info__destination">{{(holiday.destination | getDataFromMapping:'parentDestination' |
        async)?.Name}} - {{(holiday.destination | getDataFromMapping:'destination' | async)?.Name}}</h5>
      <div class="c-card-info__header">
        <h4 class="h4 c-card-title">{{holiday.title}}</h4>
        <div class="c-card-stars">
          <span>{{holiday.accomodation?.category?.value}}</span>
          <span>
            <i [ngClass]="holiday.accomodation?.category?.icon"></i>
          </span>
          <span>{{holiday.accomodation?.category?.extra}}</span>
        </div>
      </div>
    </a>

    <div class="c-card-info__detail">
      <div class="c-card-departures__item-packet" style="color: #6191E2" *ngIf="holiday.bestSolution?.packet">
        <div class="c-card-label c-card-label--inline font-weight-bold product-info">
          <span>
            <i class="g-icon-info-rounded"></i>
          </span>
          <a style="text-decoration: underline; cursor: pointer;"
             (click)="getPacketDetail(holiday.bestSolution, collapsePacket)">Informazioni sul
            pacchetto</a>
        </div>
      </div>

      <a dynamicNavigation  [href]="getDetailUrl(holiday)">

        <div *ngIf="holiday.bestSolution?.airport"
             class="c-card-label c-card-label--inline font-weight-bold">
          <i class="g-icon-bus-filled"></i> Transfer incluso
        </div>

        <div class="c-card-label c-card-label--inline">
          <i class="icon-service"></i>
          <span>{{holiday.bestSolution?.basis?.name ? holiday.bestSolution?.basis?.name : (holiday.bestSolution?.basis?.id
            | getDataFromMapping:'basis' | async)?.Name}}</span>
        </div>
        <div class="c-card-label c-card-label--inline">
          <i class="icon-arrow-thick-right"></i>
          <span>Check in: {{holiday.bestSolution?.dateFrom | date: 'd MMM'}}</span>
          <i class="icon-arrow-thick-left"></i>
          <span>Check out: {{holiday.bestSolution?.dateTo | date: 'd MMM'}}</span>
        </div>

        <div class="c-card-departures">
          <div class="c-card-departures__item"
               *ngIf="holiday.bestSolution?.airport && holiday.bestSolution?.airport<2000000 && holiday.bestSolution?.airport>1000000">
            <i class="icon-take-off"></i>
            <div class="c-card-departures__detail c-card-departures__detail--time-and-airport">
            <span *ngIf="(holiday.bestSolution?.dateFrom | date: 'HH:mm') != '00:00'">{{holiday.bestSolution?.dateFrom |
              date: 'HH:mm'}}</span>
              <span>{{(holiday.bestSolution?.airport | getDataFromMapping:'airportId' | async)?.Name}}
                ({{(holiday.bestSolution?.airport | getDataFromMapping:'airportId' | async)?.Code}})</span>
            </div>
          </div>
          <div class="c-card-departures__item"
               *ngIf="holiday.bestSolution?.airport && holiday.bestSolution?.airport>2000000 && holiday.bestSolution?.airport<3000000">
            <i class="g-icon-ship"></i>
            <div class="c-card-departures__detail c-card-departures__detail--time-and-airport">
              <span>{{holiday.bestSolution?.dateFrom | date: 'dd-MM-YYYY'}}</span>
              <span>{{(holiday.bestSolution?.airport | getDataFromMapping:'airportId' | async)?.Name}}
                ({{(holiday.bestSolution?.airport | getDataFromMapping:'airportId' | async)?.Code}})</span>
            </div>
          </div>

          <div class="c-card-departures__item" *ngIf="!holiday.bestSolution?.airport">
            <div class="c-card-departures__detail c-card-departures__detail--time-and-airport">
              <span>Solo soggiorno</span>
            </div>
          </div>

        </div>
      </a>

      <div class="c-card-tags alternative-nights" *ngIf="this.availableNights?.length">
            <span *ngFor="let nights of this.availableNights;"
                  class="c-card-tags__item"
                  [class.active]="this.holiday.bestSolution.nights === nights"
                  (click)="this.onClickOnNightsPill(nights)">
                  {{nights}} {{nights === 1 ? 'Notte' : 'Notti'}}
            </span>
      </div>

      <!--          <div class="c-card-tags">-->
      <!--            <span class="c-card-tags__item" *ngIf="holiday.bestSolution?.airport">-->
      <!--              <i class="g-icon-bus-filled"></i> Transfer incluso-->
      <!--            </span>-->
      <!--          </div>-->

    </div>
  </div>

  <a class="c-card-booking" dynamicNavigation [href]="getDetailUrl(holiday)">
    <!-- Prezzo -->
    <span class="c-card-booking__price">
      a partire da
      <ng-container *ngIf="holiday.wsHoliday">
        <span *ngIf="!holiday.bestSolution.totalPrice"> € {{holiday.bestSolution.price | number:'1.0-0'}}</span>
        <span *ngIf="holiday.bestSolution.totalPrice"> € {{holiday.bestSolution.totalPrice | number:'1.0-0'}}</span>
      </ng-container>
      <ng-container *ngIf="!holiday.wsHoliday">
        <span *ngIf="!isLoadingNetQuote && (!holiday.isCustom || (holiday.isCustom && !(holidayNetQuote | netQuote)))">€
          {{((holiday.bestSolution?.hasTotalPrice) ? holiday.bestSolution?.totalPrice : holiday.bestSolution?.price) |
            number:'1.0-0'}}</span>
      <span *ngIf="!isLoadingNetQuote && holiday.isCustom && (holidayNetQuote | netQuote)">€ {{(holidayNetQuote |
        netQuote)?.price | number:'1.0-0'}}</span>
      <span *ngIf="isLoadingNetQuote && holiday.isCustom" class="spinner-border loader" role="status"
            aria-hidden="true">
      </span></ng-container>
    </span>
    <!-- Messaggio sotto il prezzo  -->
    <span class="c-card-booking__info" *ngIf="holiday.bestSolution?.hasTotalPrice"><i class="icon-check"></i> Prezzo
      per tutti i passeggeri <span>(tasse e costi inclusi)</span></span>
    <span class="c-card-booking__info" *ngIf="!holiday.bestSolution?.hasTotalPrice"><i class="g-icon-warning"></i>
      Prezzo per singolo passeggero <span>(tasse e costi inclusi)</span>
    </span>
    <!-- LOGO CUSTOM -->
    <div class="c-card-booking__logo-custom" *ngIf="showSpecialLogo">
      <!-- geo special -->
      <img *ngIf="brand?.networkId == networks.GEO" src="./assets/images/logo_geospecial.png">
      <!-- wtg special -->
      <img *ngIf="brand?.networkId == networks.WTG" src="./assets/images/logo_welcome-special.png">
    </div>
    <!-- Call to action -->
    <div class="c-card-booking__cta">
      <a class="btn btn--light-blue font-weight-normal c-card-booking__cta__button" dynamicNavigation
        [href]="getDetailUrl(holiday)">
        <span class="c-card-booking__cta__text">Dettagli</span>
        <i class="icon-chevron-right c-card-booking__cta__icon"></i>
      </a>
    </div>
  </a>
</div>
